import { User } from 'lucide-react';
import { generateId } from '@/lib/generate-id';
import React from 'react';
import { ConditionGroup } from './ConditionGroup';
import type { BuilderGroup, BuilderState } from './segment-builder.types';
import styles from './SegmentVisualBuilder.module.css';

interface ConditionGroupListProps {
  state: BuilderState;
  onUpdate: (state: BuilderState) => void;
  disabled?: boolean;
}

export const ConditionGroupList: React.FC<ConditionGroupListProps> = ({
  state,
  onUpdate,
  disabled = false,
}) => {
  const handleGroupUpdate = (index: number, group: BuilderGroup) => {
    onUpdate({ groups: state.groups.with(index, group) });
  };

  const handleGroupDelete = (index: number) => {
    onUpdate({ groups: state.groups.toSpliced(index, 1) });
  };

  const handleAddGroup = () => {
    const newGroup: BuilderGroup = {
      id: generateId(),
      logic: 'or',
      conditions: [],
    };
    onUpdate({ groups: [...state.groups, newGroup] });
  };

  return (
    <div className={styles.contactWrapper}>
      <div className={styles.contactHeader}>
        <span className={styles.contactIcon}>
          <User size={14} />
        </span>
        <span className={styles.contactTitle}>Contact</span>
      </div>
      <div className={styles.contactBody}>
        <div className={styles.groupsAndLabel}>
          {state.groups.map((group, i) => (
            <React.Fragment key={group.id}>
              {i > 0 && (
                <div className={styles.andConnector}>
                  <span className={styles.andConnectorLabel}>AND</span>
                </div>
              )}
              <ConditionGroup
                group={group}
                onUpdate={handleGroupUpdate.bind(null, i)}
                onDelete={handleGroupDelete.bind(null, i)}
                disabled={disabled}
              />
            </React.Fragment>
          ))}
        </div>
        <div className={styles.addGroupRow}>
          <button
            type="button"
            className={styles.addGroupBtn}
            onClick={handleAddGroup}
            disabled={disabled}
            aria-label="Add condition group">
            + Add condition group
          </button>
        </div>
      </div>
    </div>
  );
};
